import React, { useRef } from 'react'
import { Loader } from 'mage-deps/@klarna/bubble-ui'
import { useHelpContext } from '../hooks'
import ViewportHeader from './ViewportHeader'
import Router from '../Router'
import ErrorBoundary from '../ErrorBoundary'
import './SidebarViewport.css'
import ChatButton from '../ChatButton'
import { selectors as conversationSelectors } from 'mage-conversation'
import { useSelector } from 'react-redux'

const MAX_CONTAINER_WIDTH = 360
const BORDER_WIDTH = 2
const MAX_VIEWPORT_WIDTH = MAX_CONTAINER_WIDTH + BORDER_WIDTH

const outterWrapper = (animationDuration, isOpen) => ({
  background: 'white',
  minWidth: isOpen ? MAX_VIEWPORT_WIDTH : 0,
  maxWidth: isOpen ? MAX_VIEWPORT_WIDTH : 0,
  overflow: 'hidden',
  paddingTop: 0,
  transition: `min-width ${animationDuration}ms`,
  flexShrink: 1,
  flexBasis: MAX_VIEWPORT_WIDTH,
  height: '100vh',
  top: 0,
  zIndex: 101
})

const innerWrapper = {
  height: '100%',
  borderLeft: `${BORDER_WIDTH}px rgba(0, 0, 0, 0.15) solid`,
  overflowY: 'auto',
  overflowX: 'hidden'
}

const containerStyle = {
  padding: 30,
  paddingBottom: 80
}

export default function SidebarViewport() {
  const scrollableContainer = useRef(null)

  const isChatAvailable = useSelector(conversationSelectors.markets).length > 0

  const {
    sidebar: { isOpen, isOpening, animationDuration }
  } = useHelpContext()

  const outerStyles = outterWrapper(animationDuration, isOpen)

  return (
    <div className="uhqm-sidebar" style={outerStyles} data-test="sidebar">
      <div ref={scrollableContainer} style={innerWrapper}>
        <ErrorBoundary showErrorPage>
          <ViewportHeader />
          <div style={containerStyle}>{renderRouter(isOpen, isOpening)}</div>
          {isChatAvailable && <ChatButton container={scrollableContainer.current} />}
        </ErrorBoundary>
      </div>
    </div>
  )
}

function renderRouter(isOpen, isOpening) {
  if (isOpening)
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Loader />
      </div>
    )

  if (isOpen) return <Router />

  return null
}
